export default (theme) => {
  return {
    headerContainer: {
      padding: '1rem 2rem',
      [theme.breakpoints.down('sm')]: {
        padding: '1rem',
      },
    },

    header: {
      color: theme.palette.common.white,
    },
  }
}
